module.exports = __webpack_public_path__ + "img/ico_vegetariano.04015fe4.svg";